import {DataTable, DataTableColumn} from "mantine-datatable";
import {Task} from "../../api/task/Task";
import DateTimeView from "../../components/date/DateTimeView";
import PageHeader from "../../components/layout/PageHeader";
import PageContent from "../../components/layout/PageContent";
import {TaskAPI} from "../../api/task/TaskAPI";
import {useEffect, useState} from "react";
import Page from "../../models/api/Page";
import {showNotification} from "@mantine/notifications";
import {useContextMenu} from "mantine-contextmenu";
import {IconTrash} from "@tabler/icons-react";
import {openConfirmModal} from "@mantine/modals";
import TaskPreview from "./TaskPreview";

const columns: DataTableColumn<Task>[] = [
    {
        accessor: 'title',
        title: 'Tytuł zadania'
    },

    {
        accessor: 'finishedAt',
        title: 'Czas zakończenia',
        render: ({finishedAt}) => <DateTimeView dateTime={finishedAt}/>
    }
];

function AssignedToMe() {
    const [loading, setLoading] = useState(false);

    const [tasks, setTasks] = useState<Page<Task>>();

    const { showContextMenu } = useContextMenu();

    const [preview, setPreview] = useState<Task>();

    const onReloadError = () => {
        showNotification({
            title: 'Nie udało się pobrać danych',
            message: 'Spróbuj ponownie później'
        });
    }

    const onMarkAsDoneError = () => {
        showNotification({
            title: 'Nie udało się oznaczyć zadania jako wykonanego',
            message: 'Spróbuj ponownie później'
        })
    }

    const doMarkAsDone = (task: Task) => {
        setLoading(true);

        TaskAPI.markAsDone(task.id)
            .then(reload)
            .then(() => showNotification({ title: 'Już!', message: 'Zadanie oznaczone jako wykonane!' }))
            .catch(onMarkAsDoneError)
            .finally(() => setLoading(false));
    }

    const markAsDone = (task: Task) => {
        openConfirmModal({
            title: "Wykonanie zadania",
            children: `Czy zadanie zostało przez Ciebie wykonane?`,
            labels: { confirm: `Tak, oznacz jako zakończone`, cancel: 'Anuluj' },
            confirmProps: {color: 'red'},
            centered: true,
            onConfirm: () => doMarkAsDone(task)
        })
    }

    const reload = () => {
        setLoading(true);

        TaskAPI.getAssignedToMe({ page: 0, limit: 20 })
            .then(setTasks)
            .catch(onReloadError)
            .finally(() => setLoading(false));
    }

    useEffect(reload, []);

    return (
        <>
            <PageHeader
                title="Zadania przypisane do mnie"
                pageTitle="Zadania przypisane do mnie"
                url="/tasks-assigned-to-me"
            />

            <PageContent>
                <DataTable
                    striped
                    highlightOnHover
                    mt="xl"
                    height="60vh"
                    withColumnBorders
                    styles={{ header: { background: 'white' } }}
                    backgroundColor={'transparent'}
                    fetching={loading}
                    minHeight={150}
                    noRecordsText={"Brak zadań przypisanych do Ciebie..."}
                    loaderBackgroundBlur={1}
                    records={tasks?.content ?? []}
                    style={{marginBottom: '50px'}}
                    columns={columns}
                    onRowContextMenu={(data) => {
                        showContextMenu([
                            {
                                title: 'Zrobione!',
                                key: 'mark-as-done',
                                onClick: () => markAsDone(data.record),
                            },

                            {
                                title: 'Podgląd',
                                key: 'preview',
                                onClick: () => setPreview(data.record),
                            }
                        ])(data.event)
                        }
                    }
                />
            </PageContent>

            <TaskPreview
                task={preview}
                isOpen={preview !== undefined}
                onClose={() => setPreview(undefined)}
            />
        </>
    );
}

export default AssignedToMe;